/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCustomerSingleUxExposure} from '../api'

export const useMutationSetCustomerSingleUxExposure = createReactQueryMutationHook('setCustomerSingleUxExposure', setCustomerSingleUxExposure)
